import React from "react";
import "../../components/LeadSourceList/LeadSourceList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const LeadSourceList = ({
  leadDetailResponse,
  setOpenProfile,
  openProfile,
  GetId,
  openAddProfile,
  setOpenAddProfile
}) => {

function HandleChange(param){
  GetId(param);
}

  return (
    <div className="container-fluid">
      <div className="leadSourceList">
        <table>
          <tr className="leadSourceListHeading">
            <th>S No.</th>
            <th>LeadSource</th>
            <th>Action</th>
          </tr>
          {leadDetailResponse !== null ? (
            leadDetailResponse.map((lead) => (
              <tr key={lead.leadsourceid}>
                <td>{lead.leadsourceid}</td>
                <td>{lead.LeadSource}</td>

                <td>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: "#F1F1F1",
                    }}                    
                    onClick={() => {
                      setOpenProfile(!openProfile);
                      HandleChange(lead.leadsourceid);
                      setOpenAddProfile(false);
                      }}
                  >
                    <EditOutlinedIcon className="icon" />
                  </button>
                  <button
                    style={{
                      height: "35px",
                      width: "35px",
                      marginLeft: "5px",
                      backgroundColor: "#F4616F",
                      borderColor: "#FF0000",
                    }}
                  >
                    <DeleteOutlinedIcon className="icon" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <p>empty</p>
          )}
        </table>
      </div>
    </div>
  );
};

export default LeadSourceList;
